import React, { FC, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  learningRequestSelector,
  learningRequestThunk,
} from '@ucheba/store/institutions/learningRequest'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { getVisitInfo } from '@ucheba/utils/hooks/useVisitsTracker'
import { authCookieToken, UCHEBA_SITE_NAME } from '@ucheba/utils/constants/core'
import { removeQueryParameters, stringifyUrl } from '@ucheba/utils/helpers/router'
import { coreQuery } from '@ucheba/utils/constants/queries'
import { getParsedCookies } from '@ucheba/utils/helpers/core'
import { IAlternativeButtonProps } from './types'

const AlternativeButton: FC<IAlternativeButtonProps> = (props) => {
  const {
    block = false,
    referId,
    type,
    size = 'medium',
    alternativeButtonView = 'default',
  } = props

  const dispatch = useDispatch()
  const { query, push, replace, asPath } = useRouter()

  const entity = useSelector(learningRequestSelector.entity)

  const isAuth = useSelector(authSelectors.isAuth)

  const isDisabledButton = useMemo(() => {
    if (!isAuth) return false

    if (type === 'program') {
      return entity?.programIds?.includes(referId)
    }

    return entity?.institutionIds?.includes(referId)
  }, [entity, type, referId, isAuth])

  const params = useMemo(() => {
    const result = {}

    Object.keys(query).forEach((key) => {
      const newKey = key.replace('[]', '')

      if (key.includes('[]') && !Array.isArray(query[key])) {
        result[newKey] = [query[key]]
      } else {
        result[newKey] = query[key]
      }
    })

    return result
  }, [query])

  const handleLearningRequest = async (): Promise<void> => {
    const parsedCookie = getParsedCookies()
    const tokenString = parsedCookie[authCookieToken]

    if (!isAuth || !tokenString) {
      const url = removeQueryParameters(asPath)

      push(
        stringifyUrl('/auth', {
          set: {
            [coreQuery.redirect]: stringifyUrl(url, {
              set: { ...params, wantToEnroll: referId },
            }),
          },
        })
      )

      return
    }

    await dispatch<any>(
      learningRequestThunk.postLearningRequest({
        data: {
          referId,
          type,
          visit: getVisitInfo(UCHEBA_SITE_NAME),
        },
      })
    )

    dispatch(learningRequestThunk.fetchLearningRequestsIds({}))
  }

  useEffect(() => {
    if (query.wantToEnroll === String(referId)) {
      delete query.wantToEnroll

      replace({ pathname: removeQueryParameters(asPath), query }, undefined, {
        shallow: true,
      })

      handleLearningRequest()
    }
  }, [])

  return (
    <div
      style={{
        backgroundColor: 'white',
        width: block ? '100%' : 'auto',
        borderRadius: '4px',
      }}
    >
      <Button
        disabled={isDisabledButton}
        onClick={handleLearningRequest}
        color='blue'
        size={size}
        block={block}
        view={alternativeButtonView}
      >
        {isDisabledButton ? 'Заявка отправлена' : 'Хочу здесь учиться'}
      </Button>
    </div>
  )
}

export default AlternativeButton
